function initFeaturedProductsSections() {
  const sections = document.querySelectorAll(
    ".custom-featured-products-slider",
  );

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const slider = section.querySelector(".swiper");

    if (!slider) {
      return;
    }

    const sliderParentEl = slider.closest(".custom-featured-products-slider");
    const buttonPrev = sliderParentEl.querySelector(".swiper-button-prev");
    const buttonNext = sliderParentEl.querySelector(".swiper-button-next");
    const scrollBar = sliderParentEl.querySelector(".swiper-scrollbar");

    const swiper = new Swiper(slider, {
      direction: "horizontal",
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 15,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      scrollbar: {
        el: scrollBar,
        dragSize: "100",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 15,
          scrollbar: {
            dragSize: "200",
          },
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
          scrollbar: {
            dragSize: "250",
          },
        },
        1080: {
          slidesPerView: 4,
          spaceBetween: 25,
          scrollbar: {
            dragSize: "300",
          },
        },
      },
    });
  });
}

function initFeaturedCollectionsSections() {
  const sections = document.querySelectorAll(
    ".custom-featured-collections-slider",
  );

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const slider = section.querySelector(".swiper");

    if (!slider) {
      return;
    }

    const sliderParentEl = slider.closest(
      ".custom-featured-collections-slider",
    );
    const buttonPrev = sliderParentEl.querySelector(".swiper-button-prev");
    const buttonNext = sliderParentEl.querySelector(".swiper-button-next");

    const swiper = new Swiper(slider, {
      direction: "horizontal",
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 15,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1080: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
    });
  });
}

function hideBadgeFromSubscribeCollection() {
  if (!document.body.classList.contains("template-subscribe")) {
    return;
  }

  const observer = new MutationObserver(() => {

    const labels = document.querySelectorAll('[data-label-id="78344"], [data-label-id="96743"]');
    
    if(!labels.length) {
      return;
    }

    labels.forEach((label) => label.classList.add('pl-hidden'));
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initFeaturedProductsSections();
  initFeaturedCollectionsSections();
  hideBadgeFromSubscribeCollection();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    initFeaturedProductsSections();
    initFeaturedCollectionsSections();
    hideBadgeFromSubscribeCollection();
  });
  document.addEventListener("shopify:section:reorder", () => {
    initFeaturedProductsSections();
    initFeaturedCollectionsSections();
    hideBadgeFromSubscribeCollection();
  });
}
